import { render, staticRenderFns } from "./info1.vue?vue&type=template&id=57502eb2&scoped=true&"
import script from "./info1.vue?vue&type=script&lang=js&"
export * from "./info1.vue?vue&type=script&lang=js&"
import style0 from "./info1.vue?vue&type=style&index=0&id=57502eb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57502eb2",
  null
  
)

export default component.exports